export const iconFontAwesomeTransportationTrainSubway = (
	<i className="fa-solid fa-train-subway"></i>
);
